import React, { useEffect, useState } from "react";
import Spinner from "./spinner";
import Image from "../components/AppImage";

const breakDuration = 1000; // ms

const getBreakStyle = (triggered, direction) => {
  if (!triggered) return {};
  const base = {
    opacity: 0,
    transform: `translate${direction === "up" ? "Y" : direction === "down" ? "Y" : "X"}(${
      direction === "up" ? "-120px" : direction === "down" ? "120px" : direction === "left" ? "-120px" : "120px"
    }) scale(0.7) rotate(${direction === "left" ? "-18deg" : direction === "right" ? "18deg" : "0deg"})`,
    transition: `all ${breakDuration}ms cubic-bezier(.5,-0.5,.5,1.5)`
  };
  return base;
};

const Loader = ({ visible = true, onBreakEnd }) => {
  const [breakApart, setBreakApart] = useState(false);

  useEffect(() => {
    if (!visible) {
      setBreakApart(true);
      const timer = setTimeout(() => {
        if (onBreakEnd) onBreakEnd();
      }, breakDuration);
      return () => clearTimeout(timer);
    } else {
      setBreakApart(false);
    }
  }, [visible, onBreakEnd]);

  if (!visible && !breakApart) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center min-h-screen w-full"
      style={{
        pointerEvents: breakApart ? "none" : "auto",
        transition: `opacity ${breakDuration}ms`,
        opacity: breakApart ? 0.7 : 1,
        // Premium, modern background with subtle green/purple accents
        background: `
          radial-gradient(ellipse at 60% 20%, rgba(80,56,120,0.13) 0%, transparent 60%),
          radial-gradient(ellipse at 20% 80%, rgba(34,70,54,0.12) 0%, transparent 60%),
          linear-gradient(135deg, #1a2e23 0%, #23213a 100%)
        `,
        boxShadow: "0 0 80px 0 rgba(80,56,120,0.08) inset",
      }}
    >
      <div className="flex flex-col items-center justify-center w-full px-4">
        <div
          className="w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 rounded-full overflow-hidden shadow-lg mb-8 border-4 border-primary/30 bg-white flex items-center justify-center"
          style={getBreakStyle(breakApart, "up")}
        >
          <Image
            src="/assets/images/school_logo-1754996036714.jpg"
            alt="Anglican College Owerrinta Logo"
            className="w-full h-full object-cover"
          />
        </div>
        <h1
          className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-primary mb-2 tracking-wide drop-shadow-lg text-center"
          style={{
            ...getBreakStyle(breakApart, "left"),
            color: "#2e4a37", // deep green accent
            textShadow: "0 2px 12px rgba(80,56,120,0.10)",
          }}
        >
          ANGLICAN COLLEGE OWERRINTA
        </h1>
        <p
          className="text-base sm:text-lg md:text-xl font-body text-center mb-6"
          style={{
            ...getBreakStyle(breakApart, "right"),
            color: "#6d5a8a", // soft purple accent
            opacity: 0.92,
            textShadow: "0 1px 8px rgba(34,70,54,0.08)",
          }}
        >
          Excellence Through Diligence
        </p>
        <div style={getBreakStyle(breakApart, "down")}>
          <Spinner message="Loading, please wait..." className="mt-2" />
        </div>
      </div>
    </div>
  );
};

export default Loader;

